import React from 'react';
import { useExplorerContext } from '@graphiql/react';
export default function FieldLink(props) {
    var push = useExplorerContext({ nonNull: true }).push;
    return (React.createElement("a", { className: "field-name", onClick: function (event) {
            event.preventDefault();
            push({ name: props.field.name, def: props.field });
        }, href: "#" }, props.field.name));
}
//# sourceMappingURL=FieldLink.js.map